import defaultTheme from './default';

// Black Friday: preto + nosso azul mais escuro (#102051).
// Só o "chrome" (navbar, footer, banners) e os destaques mudam;
// o conteúdo (cards, listas, fundo da página) continua claro.

const BLACK = '#000000';
const NEAR_BLACK = '#0A0A0A';
const NAVY = '#102051';

const { colors } = defaultTheme;

const blackFridayTheme = {
    name: 'blackFriday',
    colors: {
        ...colors,
        chrome: {
            ...colors.chrome,
            headerBg: BLACK,
            footerBg: BLACK,
            mobileMenuBg: NAVY,
            drawerBg: NEAR_BLACK,
            perfilHeaderBg: BLACK,
            perfilSidebarBg: NAVY,
            loginButtonBg: `linear-gradient(45deg, ${NAVY} 30%, #2B4AA8 90%)`,
        },
        brand: {
            ...colors.brand,
            primary: NAVY,
            deep: NEAR_BLACK,
            deepAlt: BLACK, // cards de categoria da home
            deepAltHover: NAVY,
            ink: NAVY,
            inkDark: BLACK,
            inkAlt: BLACK,
            inkAltHover: '#1A1A1A',
            accent: NAVY,
            accentSoft: NAVY,
            accentSoftHover: BLACK,
            accentBright: NAVY,
            link: NAVY,
            linkHover: BLACK,
            linkTint: '#EEF0F6',
            cashback: NAVY,
        },
        hero: {
            ...colors.hero,
            bg: `linear-gradient(135deg, ${BLACK} 0%, ${NAVY} 100%)`,
        },
        cta: {
            ...colors.cta,
            bg: BLACK,
            tint: '#EEF0F6',
        },
        images: {
            ...colors.images,
            headerBg: 'url(https://static.meucupom.com/media/BlackFriday/fundobf.png)',
            // A arte (2560x587) tem a faixa amarela em diagonal e uma área branca
            // embaixo à direita. Ancorando no topo e ampliando (~155% da altura do
            // header de 300px), aparece só a parte de cima: fundo escuro com a faixa
            // entrando no canto inferior direito, como no fundo padrão.
            headerBgPosition: 'top',
            headerBgSize: 'max(100%, 2028px) auto',
        },
    },
};

export default blackFridayTheme;
